import { useMutation } from "@apollo/client";
import { DISMISS_VETCOVE_REDIRECT } from "./dismiss-vetcove-redirect.mutation";
import { GET_PROFILE } from "../user-detail/user-detail.query";

export const useDismissVetCoveRedirect = () => {
  const [dismissVetCoveRedirect, { loading, error }] = useMutation(
    DISMISS_VETCOVE_REDIRECT,
    {
      refetchQueries: [{ query: GET_PROFILE }],
      awaitRefetchQueries: true,
    },
  );

  return { dismissVetCoveRedirect, loading, error };
};
